import checkInputs from "../../../utils/checkInputs";

const validations = {
  editCostumer: function validationEditUser(updatedCostumer) {
    const errors = {};
    if (!checkInputs.notNull(updatedCostumer.nombres)) {
      errors.nombres = "Es necesario.";
    } else if (!checkInputs.isAlphanumeric(updatedCostumer.nombres)) {
      errors.nombres = "Los nombres solo contienen letras.";
    } else if (updatedCostumer.nombres.length > 300) {
      errors.nombres = "No ingrese más de 300 caracteres.";
    }

    let regex = new RegExp("[0-9]{3,4}-[0-9]{4}");
    if (updatedCostumer.telefono) {
      if (!checkInputs.isAlphanumeric(updatedCostumer.telefono)) {
        errors.telefono = "No puede contener caracteres especiales, solo: '(',')', '#', letras y números .";
      } else if (
        updatedCostumer.telefono.length < 7 ||
        updatedCostumer.telefono.length > 12
      ) {
        errors.telefono =
          "La cantidad de dígitos debe estar entre 7 (convencionales) a 12 (teléfonos celulares).";
      } else if (!regex.test(updatedCostumer.telefono)) {
        errors.telefono = 'El formato del teléfono no es correcto.';
      }
    }

    if (updatedCostumer.direccion) {
      if (!checkInputs.isAlphanumeric(updatedCostumer.direccion)) {
        errors.direccion =
          "Solo ingrese: letras, números, '#', '.' o paréntesis";
      } else if (updatedCostumer.direccion.length > 300) {
        errors.direccion = "No ingrese más de 300 caracteres.";
      }
    }

    if (!checkInputs.notNull(updatedCostumer.correo)) {
      errors.correo = "El correo es necesario.";
    } else if (!checkInputs.validationEmail(updatedCostumer.correo)) {
      errors.correo =
        "El correo es incorrecto. Debe contener el usuario, @ y el dominio.";
    } else if (updatedCostumer.correo.length > 300) {
      errors.correo = "No ingrese más de 300 caracteres.";
    }

    if (updatedCostumer.cliente.tipoReceptor === "04") {
      if (checkInputs.notNull(updatedCostumer.ubicacionGeografica)) {
        errors.ubicacionGeografica = "No ingresar la ubicación geográfica, el cliente es extranjero."
      }
    }
    if (updatedCostumer.cliente.tipoReceptor === "01" || updatedCostumer.cliente.tipoReceptor === "03") {
      if (!checkInputs.notNull(updatedCostumer.ubicacionGeografica)) {
        errors.ubicacionGeografica = "La ubicación geográfica es necesaria."
      }
    }
    return errors;
  },
  addPartner: function validationAddCostumer(newPartner) {
    const errors = {};
        if (!checkInputs.notNull(newPartner.rucEmpresa)) {
            errors.rucEmpresa = "El RUC de la empresa es necesario."

        } else if (!checkInputs.isAlphanumeric(newPartner.rucEmpresa)) {
            errors.rucEmpresa = 'No puede contener caracteres especiales, solo letras o números.';
        } else if (newPartner.rucEmpresa.length > 20) {
            errors.rucEmpresa = 'No ingrese más de 20 caracteres.';
        }


        if (!checkInputs.notNull(newPartner.razonSocial)) {
            errors.razonSocial = "La razón social es necesaria."
        } else if (!checkInputs.isAlphanumeric(newPartner.razonSocial)) {
            errors.razonSocial = 'No puede contener caracteres especiales, solo letras o números.';
        } else if (newPartner.razonSocial.length > 100 || newPartner.razonSocial.length < 2) {
            errors.razonSocial = 'No ingrese entre 2 y 100 caracteres.';
        }

        if (!checkInputs.notNull(newPartner.dvEmpresa)) {
            errors.dvEmpresa = "El dígito verificador es necesario."
        } else if (!checkInputs.isNumeric(newPartner.dvEmpresa)) {
            errors.dvEmpresa = 'El dígito verificador solo puede contener números.';
        } else if (newPartner.dvEmpresa.length > 2) {
            errors.dvEmpresa = 'No ingrese más de 2 dígitos.';
        }

        if (!checkInputs.notNull(newPartner.correoElectronico)) {
            errors.correoElectronico = "El correo electrónico es necesario."
        } else if (!checkInputs.validationEmail(newPartner.correoElectronico)) {
            errors.correoElectronico = "No puede contener caracteres especiales, solo: '(',')', '#', letras y números .";
        } else if (newPartner.correoElectronico.length > 50) {
            errors.correoElectronico = 'No ingrese más de 50 caracteres.';
        }

        let regex = new RegExp("[0-9]{3,4}-[0-9]{4}");
        if (!checkInputs.notNull(newPartner.telefono)) {
            errors.telefono = "El teléfono es necesario."
        } else if (!checkInputs.isAlphanumeric(newPartner.telefono)) {
            errors.telefono = "No puede contener caracteres especiales, solo: '(',')', '#', letras y números .";
        } else if (newPartner.telefono.length > 12 || newPartner.telefono.length < 7) {
            errors.telefono = 'No ingrese entre 7 y 12 caracteres.';
        } else if (!regex.test(newPartner.telefono)) {
            errors.telefono = 'El formato del teléfono no es correcto.';
        }

        if (!checkInputs.notNull(newPartner.unificadoSucursal)) {
            errors.unificadoSucursal = "La ubicación geográfica es necesaria."
        }

        let regexCoordenadas = new RegExp("[+-]{0,1}[0-9]{1,2}[.]{1}[0-9]{4,6}[,]{1}[+-]{0,1}[0-9]{1,2}[.]{1}[0-9]{4,6}");
        if (!checkInputs.notNull(newPartner.coordenadaSucursal)) {
            errors.coordenadaSucursal = "La coordenada de la sucursal es necesaria."
        } else if (!checkInputs.isAlphanumeric(newPartner.coordenadaSucursal)) {
            errors.coordenadaSucursal = "No puede contener caracteres especiales, solo: '(',')', '#', letras y números .";
        } else if (newPartner.coordenadaSucursal.length > 22) {
            errors.coordenadaSucursal = 'No ingrese más de 22 caracteres.';
        } else if (!regexCoordenadas.test(newPartner.coordenadaSucursal)) {
            errors.coordenadaSucursal = 'El formato de la coordenada de la sucursal no es correcto.';
        }

        if (!checkInputs.notNull(newPartner.direccionEmpresa)) {
            errors.direccionEmpresa = "La dirección es necesaria."
        } else if (!checkInputs.isAlphanumeric(newPartner.direccionEmpresa)) {
            errors.direccionEmpresa = "No puede contener caracteres especiales, solo: '(',')', '#', letras y números .";
        } else if (newPartner.direccionEmpresa.length > 100) {
            errors.direccionEmpresa = 'No ingrese más de 100 caracteres.';
        }



        if (checkInputs.notNull(newPartner.numeroResolucion)) {
            if (!checkInputs.isNumeric(newPartner.numeroResolucion)) {
                errors.numeroResolucion = 'No puede contener caracteres especiales, solo números.';
            } else if (newPartner.numeroResolucion.length > 13) {
                errors.numeroResolucion = 'No ingrese más de 13 caracteres.';
            }
        }


        return errors;
  },
};

export default validations;
